module.exports = __webpack_public_path__ + "static/media/hand.9ecdf0b1.svg";